import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'
import { EliminarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdGrupoContableGastoFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  gruposContablesGasto,
  actualizarGruposContablesGasto
}) => {
  const [mostrarSeleccionarCuentaModal, setMostrarSeleccionarCuentaModal] = React.useState(false)
  const [mostrarEliminarCuentaModal, setMostrarEliminarCuentaModal] = React.useState(false)
  const [dataGrupoContable, setDataGrupoContable] = React.useState(null)

  React.useEffect(() => {
    if (gruposContablesGasto.length === 1) {
      values.cuentaContableGasto = gruposContablesGasto[0]._id
      setValues(values)
    }
  }, [gruposContablesGasto, values, setValues])

  const onSuccess = React.useCallback(async () => {
    actualizarGruposContablesGasto()
    setMostrarSeleccionarCuentaModal(false)
  }, [actualizarGruposContablesGasto])

  const clickEliminarGrupoContable = React.useCallback(() => {
    const found = gruposContablesGasto.find(x => x._id === values.cuentaContableGasto)
    if (!found) return
    TablaPersonalizadaService.getAsEdicion(found.id).then(({ data }) => {
      setDataGrupoContable(data)
      setMostrarEliminarCuentaModal(true)
    })
  }, [values, gruposContablesGasto])

  return (
    <>
      <Form.Group>
        <Form.Label text='GASTO' htmlFor='select-gContablesGasto' sm={2} md={3} lg={2} alignRightAt='sm' />
        <Col sm={10} md={9} lg={10}>
          <Form.InputGroup>
            <Field name='cuentaContableGasto'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-gContablesGasto'
                >
                  <option value=''>Seleccionar</option>
                  {gruposContablesGasto &&
                    gruposContablesGasto.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarSeleccionarCuentaModal(true)}>+</Button>
              <Button className='bg-danger border border-danger' onClick={() => clickEliminarGrupoContable()}>
                -
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarSeleccionarCuentaModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarSeleccionarCuentaModal(false)}
          show={mostrarSeleccionarCuentaModal}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEGASTO}
        />
      )}
      {mostrarEliminarCuentaModal && (
        <EliminarTablaPersonalizadaModal
          handleClose={e => setMostrarEliminarCuentaModal(false)}
          show={mostrarEliminarCuentaModal}
          modalData={dataGrupoContable}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEGASTO}
        />
      )}
    </>
  )
}

export default React.memo(IdGrupoContableGastoFormGroup)
